import PropTypes from 'prop-types';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import classNames from 'classnames';

import { updateEventTypes } from '~/features/updateEvents/constants/updateEventTypes';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';

export const UpdateEventType = ({ value }) => {
    if (!value) {
        return null;
    }
    return (
        <OverlayTrigger placement='top' overlay={
            <Tooltip id='tooltip' className='top-right'>
                <FormattedMessage id={updateEventTypes[value].tooltip}/>
            </Tooltip>}>
            <span className={classNames('label label-condensed', updateEventTypes[value].className)}>
                <FormattedMessage id={updateEventTypes[value].label} />
            </span>
        </OverlayTrigger>
    );
};

export default UpdateEventType;

UpdateEventType.propTypes = {
    // props
    value: PropTypes.string,
};
